// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"fc666223","150":"72e93322","253":"61fd6603","434":"46bb4097","483":"316c1f8e","488":"e6dbfee5","554":"099bec7f","823":"4b8031d1","949":"a4cf2ace","983":"72d7b3fe"}[chunkId] + ".chunk.js";
};